export const onChangeOfferValueAction = (props: any) => {
	const { setValue, name } = props;
	const valueInString = document.getElementsByName(name)[0].value?.replace(/[.,]/g, '');
	if (!Number.isNaN(valueInString)) {
		let value = Math.floor(Number(valueInString));
		if (value < 0) value = 0;
		setValue(name, value.toLocaleString('en-IN'));
	}
};
